import React from 'react';
import {motion} from 'framer-motion';
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components';
import Links from './Links';

import {BsFillDoorOpenFill} from 'react-icons/bs';
import {GrMail} from 'react-icons/gr';
import {HiLocationMarker} from 'react-icons/hi';


function Drawer({setOpen}) {

    const HalfDrawerVariants = {
        initial:{
            x: "110%"
        },
        animate:{
            x: 0
        },
        exit: {
            x: "110%"
        }
    }

    const navigate = useNavigate();
    const handleClick=(name)=>{
        // window.removeEventListener("wheel", handleScroll);
        setOpen(false);
        navigate(`/${name}`);
    }

  return (
    <DrawerFullWrapper>
        <motion.div className='drawer-half-wrapper'
            variants={HalfDrawerVariants} initial="initial" animate="animate" exit="exit"
        >
            <BsFillDoorOpenFill size={25} className="door clickable" onClick={()=>setOpen(false)} />
            <ul className="drawer-menu">
                <li className='clickable title-lead' onClick={()=>handleClick("")} >Home</li>
                <li className='clickable title-lead' onClick={()=>handleClick("aboutdetail")} >About</li>
                <li className='clickable title-lead' onClick={()=>handleClick("projectsdetail")} >Projects</li>
                <li className='clickable title-lead' onClick={()=>handleClick("contact")} >Contact</li>
            </ul>
            <div className="utilities">
                <div className="contact-flex">
                    <GrMail className='icons' />
                    <p ><a href='mailto: devbatra1000@gmail.com' >devbatra1000@gmail.com</a></p>
                </div>
                <div className="contact-flex">
                    <HiLocationMarker className='icons' />
                    <p >Meerut, India.</p>
                </div>
                <Links/>
            </div>
        </motion.div>
    </DrawerFullWrapper>
  )
}

const DrawerFullWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #021e28ad;
    z-index: 10000;
    
    .door{
        position: absolute;
        top: 4rem;
        right: 4rem;
    }
    
    .drawer-half-wrapper{
        padding: 0 3rem;
        width: 30%;
        background-color: var(--primary);
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;
    }

    .drawer-menu{
        display: flex;
        flex-direction: column;
        margin: 7rem 0 2rem 0rem;
    }
    li{
        padding: 1rem 0.5rem;
        list-style: none;
        /* border: 2px solid red; */
        transition: all 0.5s ease;
    }
    li:hover{
        text-decoration: line-through;
    }

    .contact-flex{
        display: flex;
        align-items: center;
        margin: 1rem 0rem;
    }
    .icons{
        margin-right: 1rem;
        font-size: 1.3rem;
    }

    @media only screen and (max-width: 1080px){
        .drawer-half-wrapper{
            width: 60%;
        }
    }

    @media only screen and (max-width: 500px){
        .drawer-half-wrapper{
            width: 80%;
        }
    }

`

export default Drawer;